export const languages = [
    { locale_id : 'en-US', name:'English' },
    { locale_id : 'ko', name:'한글' },
    { locale_id : 'vi', name:'Vietnamese' },
];